module.exports = {
	"widget-system": 232
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/bi/events.json
// module id = 1190
// module chunks = 0 1 2 3 4